import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Modal from '../ui/modal';
import { getTableColumns } from './network';
const FilterConfigModal = ({ isOpen, onClose, onSave, tables, existing }) => {
    const [selected, setSelected] = React.useState(new Map());
    const [tableColumns, setTableColumns] = React.useState(new Map());
    const [loading, setLoading] = React.useState(new Set());
    React.useEffect(() => {
        const map = new Map();
        for (const cfg of existing) {
            map.set(`${cfg.tableName}:${cfg.column}`, cfg);
        }
        setSelected(map);
    }, [existing, isOpen]);
    // Fetch columns for all tables when modal opens
    React.useEffect(() => {
        if (!isOpen)
            return;
        for (const tableName of tables) {
            if (tableColumns.has(tableName))
                continue;
            setLoading(prev => new Set(prev).add(tableName));
            getTableColumns(tableName)
                .then(columns => {
                setTableColumns(prev => new Map(prev).set(tableName, columns));
            })
                .catch(() => {
                setTableColumns(prev => new Map(prev).set(tableName, []));
            })
                .finally(() => {
                setLoading(prev => {
                    const next = new Set(prev);
                    next.delete(tableName);
                    return next;
                });
            });
        }
    }, [isOpen, tables]);
    const toggle = (tableName, column, kind, label) => {
        const key = `${tableName}:${column}`;
        setSelected(prev => {
            const next = new Map(prev);
            if (next.has(key)) {
                next.delete(key);
            }
            else {
                next.set(key, { column, tableName, kind, label });
            }
            return next;
        });
    };
    const handleSave = () => {
        onSave(Array.from(selected.values()));
        onClose();
    };
    return (_jsxs(Modal, { isOpen: isOpen, title: "Configure Dashboard Filters", size: "lg", onClose: onClose, children: [_jsx("p", { className: "text-muted small mb-3", children: "Select columns to use as dashboard-level filters. Filters apply to all widgets that query the same table." }), tables.length === 0 ? (_jsx("div", { className: "text-muted text-center py-3", children: "No data sets available" })) : (_jsx("div", { style: { maxHeight: 400, overflowY: 'auto' }, children: tables.map(tableName => {
                    const columns = tableColumns.get(tableName) || [];
                    const isLoading = loading.has(tableName);
                    return (_jsxs("div", { className: "mb-3", children: [_jsxs("h6", { className: "fw-medium mb-2", children: [_jsx("i", { className: "bi bi-table me-1 text-muted" }), tableName] }), _jsx("div", { className: "ms-3", children: isLoading ? (_jsxs("div", { className: "text-muted small", children: [_jsx("span", { className: "spinner-border spinner-border-sm me-1", style: { width: '0.7rem', height: '0.7rem' } }), "Loading columns..."] })) : columns.length === 0 ? (_jsx("div", { className: "text-muted small", children: "No columns" })) : (columns.map(col => {
                                    const key = `${tableName}:${col.columnName}`;
                                    const isSelected = selected.has(key);
                                    return (_jsxs("div", { className: "form-check mb-1", children: [_jsx("input", { className: "form-check-input", type: "checkbox", id: key, checked: isSelected, onChange: () => toggle(tableName, col.columnName, col.dataType, col.columnName) }), _jsxs("label", { className: "form-check-label small", htmlFor: key, children: [col.columnName, _jsxs("span", { className: "text-muted ms-1", children: ["(", col.dataType, ")"] })] })] }, key));
                                })) })] }, tableName));
                }) })), _jsxs("div", { className: "d-flex justify-content-between align-items-center mt-3", children: [_jsxs("span", { className: "text-muted small", children: [selected.size, " filter", selected.size !== 1 ? 's' : '', " selected"] }), _jsxs("div", { className: "d-flex gap-2", children: [_jsx("button", { className: "btn btn-sm btn-outline-secondary", onClick: onClose, children: "Cancel" }), _jsxs("button", { className: "btn btn-sm btn-primary", onClick: handleSave, children: [_jsx("i", { className: "bi bi-check-lg me-1" }), "Save Filters"] })] })] })] }));
};
export default FilterConfigModal;
